<template>
  <section class="section container pt-3">
    <variable-set-datatable ref="variable_set_datatable" />
  </section>
</template>

<script>
import VariableSetDatatable from "./variable_set_datatable/Index.vue";

export default {
  name: "NgineVariableSetIndex",
  components: { VariableSetDatatable },
  data() {
    return {};
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
